<template>
  <ODataTable class="fixed-table dense-table" :spec="spec" :items="rows" />
</template>

<script>
import { brNum, dt } from 'oderon-commons/src/formatters'
import ODataTable from 'oderon-vue/cpts/ODataTable'
import _ from 'lodash'
import brush from 'brush'

function decHex(x) {
  if (x == null) return '-'
  return {
    html: `${brNum(x)} <code>0x${brush.toHexString(x)}</code>`
  }
}

function hasGps(hb) {
  let flag = _.get(hb, 'summary.hasGps')
  if (flag == false) return false

  if (
    hb.latitude == 0 ||
    hb.longitude == 0 ||
    hb.latitude >= 90 ||
    hb.latitude <= -90 ||
    hb.longitude <= -180 ||
    hb.longitude >= 180
  ) {
    return false
  }

  return true
}

function getIndicators(row) {
  let h = row.summary
  let result = [
    ['En', 'on', h.engineOn],
    ['Sp', 'on', h.hasSpeed],
    ['RD', 'on', h.rawDataLength > 0],
    ['NF', 'on', !hasGps(row)],
    ['PD', 'on', h.hasDumpedPointer],
    ['PC', 'on', h.hasPointerCorrection],
    ['Sk', 'on', h.skipped],
    ['SD', 'on', _.get(h, 'variables.shutdownReason') != null],
    ['DO', 'on', h.drainedOut]
  ].map((i) => {
    let c = i[2] ? i[1] : ''
    return `<span title="${i[0]}" class="${c}">${i[0]}</span>`
  })

  return { html: `<span class="hb-indicators large">${result.join('')}</span>` }
}

export default {
  components: { ODataTable },
  props: {
    rows: { type: Array }
  },
  data() {
    return {
      spec: {
        columns: [
          { t: 'HB ID|', d: 'id', w: 110 },
          { t: 'Indicadores', d: (row) => getIndicators(row), w: 260 },
          { t: 'Recebido em|', d: 'receivedOn', f: dt, w: 180 },
          { t: 'RD Len|', d: 'summary.rawDataLength', f: brNum, w: 100 },
          {
            t: 'Ponteiro inicial|',
            d: 'originalLastPointer',
            f: decHex,
            w: 250
          },
          { t: 'Ponteiro final|', d: 'summary.endPointer', f: decHex, w: 250 }
        ],
        defaultSortable: false
      }
    }
  }
}
</script>

<style></style>
